import React from "react";
import Login from "feature/authv2/pages/Login";
import PortalSelect from "feature/authv2/pages/PortalDesk";
import { DESK_RBAC } from "feature/authv2/portalDeskConfig";

const authV2Routes = {
  standalone: [
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/desk",
      element: <PortalSelect />,
      protected: true,
      // authorized: DESK_RBAC,
    },
  ],
};

export default authV2Routes;
